import {Configuration, ChannelApi as DictionariesApi, LeadgenJKListResponse, LeadgenJK} from "../generated";
import {City} from "../../../domain/city/city";
import {AmoStatus} from "../../../domain/amostatus/amostatus";
import {DictionariesInterface} from "../../../useCase/dictionaries/adapters/dictionary";
import {Auto} from "../../../domain/auto/auto";
import {Jk} from "../../../domain/jk/jk";

export class DictionariessRepository implements DictionariesInterface {
    private service: DictionariesApi;
    // private dmp: DmpCarsApi;

    constructor() {
        this.service = new DictionariesApi(
            new Configuration(),
            process.env.REACT_APP_BACKEND_URL
        );
        // this.dmp = new DmpCarsApi(new Configuration(),
        //     process.env.REACT_APP_BACKEND_URL)
    }


    async GetCityList(): Promise<Auto[] | Error> {
        let cityList: City[] = [];
        let response = await this.service.apiChannelCityGet({
            headers: {Authorization: localStorage.getItem("token")},
        });

        if (response.status === 200) {
            response.data.list.forEach((cityInp) => {
                let city = new City(cityInp.id, cityInp.name);
                cityList.push(city);
            });
        }

        if (response.status === 401) {
            return Error("error authorization");
        }

        return cityList;
    }

    async GetCityJkForId(id:string): Promise<Jk[] | Error> {
        let jkArr: Jk[] = [];
        let response = await this.service.apiChannelJkCityIdGet(id,{
            headers: {Authorization: localStorage.getItem("token")},
        });

        if (response.status === 200) {
            response.data.list!.forEach((jk) => {
                let jkList = new Jk(jk.id!, jk.name!, jk.code!);
                jkArr.push(jkList);
            });
        }

        if (response.status === 401) {
            return Error("error authorization");
        }

        return jkArr;
    }

    async GetAutoTypeList(): Promise<Auto[] | Error> {
        let autoList: Auto[] = [];
        let response = await this.service.apiChannelCarModelsGet({
            headers: {Authorization: localStorage.getItem("token")},
        });

        if (response.status === 200) {

            response.data.list!.forEach((autoInp) => {
                let auto = new Auto(autoInp.id!, autoInp.name!);
                autoList.push(auto);
            });

        }

        if (response.status === 401) {
            return Error("error authorization");
        }

        return autoList;
    }

    async GetStatusList(): Promise<AmoStatus[] | Error> {
        let amoStatusList: AmoStatus[] = [];
        let response = await this.service.apiChannelAmostatusGet({
            headers: {Authorization: localStorage.getItem("token")},
        });

        if (response.status === 200) {
            response.data.list.forEach((amoStatusInp) => {
                let amoStatus = new AmoStatus(
                    amoStatusInp.statusId,
                    amoStatusInp.statusName,
                    amoStatusInp.pipelineId,
                    amoStatusInp.pipelineName
                );
                amoStatusList.push(amoStatus);
            });
        }

        if (response.status === 401) {
            return Error("error authorization");
        }

        return amoStatusList;
    }
}
